package us.laantech.admin.pages

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Button
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.launch
import us.laantech.admin.ENV
import us.laantech.admin.api.startOAuthLogin
import us.laantech.common.api.KtorClient


@Composable
fun LoginView(
    onLoginSuccess: () -> Unit = {},
    modifier: Modifier = Modifier,
) {
    val scope = rememberCoroutineScope()

    val gradientColors = listOf(
        Color(13, 53, 95),
        Color(13, 53, 95)
    )

    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center,
        modifier = modifier
            .fillMaxSize()
            .background(brush = Brush.verticalGradient(colors = gradientColors))
    ) {
        Text(
            text = "LAAN Admin",
            style = MaterialTheme.typography.headlineLarge,
            color = Color(255, 255, 255),
            modifier = Modifier.padding(bottom = 16.dp)
        )

        Button(
            onClick = {
                scope.launch {
                    val code = startOAuthLogin()
                    if (code != null) {
                        KtorClient.instance.exchangeCodeForTokens(
                            authorizationCode = code,
                            redirectUri = ENV.COGNITO_CALLBACK_URL,
                        )
                        onLoginSuccess()
                    }
                }
            },
            modifier = Modifier.padding(16.dp)
        ) {
            Text(
                "Login",
                style = MaterialTheme.typography.headlineSmall
            )
        }
    }
}
